import { Component, Input, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';
import { OrganizationService } from '../../services/organization.service';

@Component({
    selector: 'cso-breadcrumb-tooltip',
    templateUrl: './cso-breadcrumb-tooltip.component.html',
    styleUrls: ['./cso-breadcrumb-tooltip.component.css']
})
/** cso-breadcrumb-tooltip component*/
export class CsoBreadcrumbTooltipComponent implements OnInit {
/** cso-breadcrumb-tooltip ctor */
  @Input() parentOrganizationTree: any[] = [];

  constructor(private _organizationService: OrganizationService, private _logger: LogService)
  { }

  ngOnInit(): void {
    //this.setCSOid(0);
    }

  setCSOid(org: any): void {
    this._logger.log("setCSOid", org);
  }
}
